import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { getDeviationType } from '../../../../_helpers';
import { DeviationTypes } from '../../../../../types/deviation';
import { createMergingContextProvider } from '../../../../../utils/createMergingContextProvider';
export var OverlayContext = React.createContext({
    showFaveControl: true,
    showCommentControl: true,
    showAuthor: true,
    showAuthorName: true,
    showPremiumFolderOverlay: true,
    showPremiumFolderIcon: true,
    showSuggestedReasonLabel: true,
    showDailyDeviationLabel: true,
});
OverlayContext.displayName = 'OverlayContext';
export var OverlayContextProvider = createMergingContextProvider(OverlayContext);
// almost same as useContext(OverlayContext), but with correct defaults
export function useOverlayContext(deviation, showTitleDefault) {
    if (showTitleDefault === void 0) { showTitleDefault = true; }
    var deviationType = getDeviationType(deviation);
    var canShowTitle = ![
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE,
        DeviationTypes.POLL,
        DeviationTypes.STATUS,
    ].includes(deviationType);
    var _a = useContext(OverlayContext), _b = _a.showFaveControl, showFaveControl = _b === void 0 ? true : _b, _c = _a.showCommentControl, showCommentControl = _c === void 0 ? true : _c, _d = _a.showAuthor, showAuthor = _d === void 0 ? true : _d, _e = _a.showPremiumFolderOverlay, showPremiumFolderOverlay = _e === void 0 ? true : _e, _f = _a.showPremiumFolderIcon, showPremiumFolderIcon = _f === void 0 ? true : _f, _g = _a.showSuggestedReasonLabel, showSuggestedReasonLabel = _g === void 0 ? true : _g, _h = _a.showDailyDeviationLabel, showDailyDeviationLabel = _h === void 0 ? true : _h, showTitle = _a.showTitle, _j = _a.showStats, showStats = _j === void 0 ? true : _j, _k = _a.showAuthorName, showAuthorName = _k === void 0 ? true : _k, _l = _a.showExtraActions, showExtraActions = _l === void 0 ? true : _l, restContext = __rest(_a, ["showFaveControl", "showCommentControl", "showAuthor", "showPremiumFolderOverlay", "showPremiumFolderIcon", "showSuggestedReasonLabel", "showDailyDeviationLabel", "showTitle", "showStats", "showAuthorName", "showExtraActions"]);
    return __assign({ showFaveControl: showFaveControl,
        showCommentControl: showCommentControl,
        showAuthor: showAuthor,
        showPremiumFolderOverlay: showPremiumFolderOverlay,
        showPremiumFolderIcon: showPremiumFolderIcon,
        showSuggestedReasonLabel: showSuggestedReasonLabel,
        showDailyDeviationLabel: showDailyDeviationLabel, showTitle: canShowTitle && (showTitle !== null && showTitle !== void 0 ? showTitle : showTitleDefault), showStats: showStats,
        showAuthorName: showAuthorName,
        showExtraActions: showExtraActions }, restContext);
}
//# sourceMappingURL=OverlayContext.js.map